import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../_helpers/breakpoints';
import moment from 'moment';
import { RiCloseCircleLine } from "react-icons/ri";
import { IoCloseSharp } from "react-icons/io5";

import CircularProgress from '@material-ui/core/CircularProgress';

import { } from '../../_elements';

import { ContentContext } from '../../_context';

const QuestionStyled = styled.div`
    .highlighted{
        color: #FFC600;
        font-weight: 700;
        font-style: italic;
    }
  .evaluation_answers{
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    .evaluation_answer{
      border: 1px solid #FFC600;
      box-sizing: border-box;
      padding: 15px 35px;
      border-radius: 15px;
      margin-right: 10px;
      text-align: center;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      cursor: pointer;
      :last-child{
        margin-right: 0;
      }
      :hover{
        background-color: #FFC600;
        //color: #FFFFFF;
      }
      &.selected{
        background-color: #FFC600;
      }
    }
  }
  .image{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 15px;
    width: 100%;
    >.inner{
      width: 350px;
      img{
        float: left;
        width: 100%;
      }
    }
  }
  @media ${breakpoints.xs} {
  }
  @media ${breakpoints.sm} {
  }
  @media ${breakpoints.md} {
    
  
  }
  @media ${breakpoints.lg} {

  }
`

const CompleteBlanks = (props) => {

  const { multiple,
          secondary_actions,
          order,
          answersSelected,
          setAnswersSelected,
          answerEvaluation,
          setAnswerEvaluation,
          question = null,
          setCompleteBlanks} = props

  const { evaluationActive,
          setEvaluationActive,
          evaluation,
          setEvaluation,
          take_user_evaluation } = useContext(ContentContext);

  const [ questionText, setQuestionText ] = useState([]);
  const [ secondaryActionsShuffled, setSecondaryActionsShuffled ] = useState([]);
  const handleAnswer = (answer, _id) => {
//console.log(answer, _id, questionText, answer.label);
      let replaced = false;
      let updatedText = [];

      const exist = questionText.filter(part => part === "<span class='highlighted'>"+answer.label+"</span>");
      if(!exist.length){
          updatedText = questionText.map(part => {
              if (part === "____" && !replaced) {
                  replaced = true;
                  return "<span class='highlighted'>"+answer.label+"</span>";
              }
              return part;
          });
      }else{
          updatedText = questionText.map(part => {
              if (part === "<span class='highlighted'>"+answer.label+"</span>" && !replaced) {
                  replaced = true;
                  return "____";
              }
              return part;
          });
      }
      
      setCompleteBlanks(updatedText.join(" ").replace(/<span[^>]*>(.*?)<\/span>/gi, "$1"));
      setQuestionText(updatedText);
      
      if(!answersSelected.includes(_id)){
        setAnswersSelected([...answersSelected, _id])
      }
      else{
        const filtered = answersSelected.filter(answer => answer != _id);
        setAnswersSelected(filtered);
      }
  }

  const shuffleArray = (array) => {
          const arr = [...array];
          for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
          }
          return arr;
        };

  useEffect(() => {

    if(question){
        setQuestionText(question.title.split(/(____)/).map(part => part.trim()));
        setSecondaryActionsShuffled(shuffleArray(secondary_actions));
    }
  
    return () => {}
  }, [])

  
  

  return (
    <QuestionStyled className={''}>
        
        <div className='evaluation_question' dangerouslySetInnerHTML={{ __html: questionText ? questionText.join(" ") : ""}} />

        {/* <div className='evaluation_question'>
            {questionText ? questionText.join(" ") : ""}
        </div> */}

      {(question && question.media.length) ?
      <div className='image'>
        <div className='inner'>
          <img src={question.media} />
        </div>
      </div>
      : ""}

      <div className='evaluation_answers'>
        {secondaryActionsShuffled && secondaryActionsShuffled.map((answer, index) => {
          return(
            <div className={`evaluation_answer${answersSelected.includes(answer._id) ? ' selected' : ""}`} onClick={ () => handleAnswer(answer, answer._id) }>
              {answer.label}
            </div>
          )
        })}
      </div>

    </QuestionStyled>
  )
}

export default CompleteBlanks;
